import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

export default function Layout() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const location = useLocation();

  // Auto-close the mobile drawer on route change so the user lands on the
  // destination page cleanly without having to tap the backdrop.
  useEffect(() => { setMobileNavOpen(false); }, [location.pathname]);

  // Prevent background scroll while the drawer is open on mobile.
  useEffect(() => {
    if (mobileNavOpen) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => { document.body.style.overflow = prev; };
    }
  }, [mobileNavOpen]);

  return (
    <div className="min-h-screen flex bg-slate-50" data-testid="app-shell">
      <Sidebar mobileOpen={mobileNavOpen} onCloseMobile={() => setMobileNavOpen(false)} />
      <div className="flex-1 flex flex-col min-w-0">
        <Topbar onOpenMobileNav={() => setMobileNavOpen(true)} />
        <main className="flex-1 min-w-0">
          <div className="mx-auto max-w-[1500px] p-3 sm:p-5 md:p-8 animate-fade-up">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
